export const mapThemingColor = (value, theme, defaultValue) => {
  if (value === 'default') return defaultValue
  if (value === 'primary') return 'var(--color-primary-500)'
  if (value === 'primaryContrast') return 'var(--color-primary-050)'
  return value || defaultValue
}
